import { useEffect } from "react";

import { useGetUser } from "../user-api";
import { useLazyGetTeamsByLeagueQuery } from "./team-api";

export const useGetTeamsByUserLeague = () => {
  const { user } = useGetUser();
  const [getTeamsByLeague, teams] = useLazyGetTeamsByLeagueQuery();

  useEffect(() => {
    if (user) getTeamsByLeague({ league: user.userDetails.leagueId });
  }, [user, getTeamsByLeague]);

  return teams;
};
